// extracted by mini-css-extract-plugin
export default {"buttons":"Submit_buttons__PA4Vm","buttonCreateRevoting":"Submit_buttonCreateRevoting__oxWXI"};